import TaxRatePanel from './TaxRatePanel';
export default TaxRatePanel;
